import { IgButton } from "@intelligems/ig-theme/IgButton";
import { useDispatch } from "@src/store";
import { ExperienceBuilderAction } from "@src/store/slices/experienceBuilder";
import { EmbeddedPreviewError } from "@src/features/experienceBuilder/pageState/EmbeddedPreviewError";
import { GENERAL_ROUTES } from "@src/routes/routes";

interface NetworkBlockedErrorProps {
  url: string;
}

/**
 * Opening the preview in its own tab shows whatever the blocker answers with.
 * A company web filter's block page usually names the filter and the category
 * it blocked us under, which is what support needs to get us unblocked.
 * Support confirms the block before anyone involves the customer's IT team.
 */
export const NetworkBlockedError = ({ url }: NetworkBlockedErrorProps) => {
  const dispatch = useDispatch();

  return (
    <EmbeddedPreviewError
      title={"Your browser cannot reach our server"}
      description={
        "Something stops your browser from reaching the server that shows your store here. Open the preview in a new tab and take a screenshot of what you see. Send it to our support team."
      }
      buttons={
        <>
          <IgButton
            variant="contained"
            color="warning"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ flex: 1, whiteSpace: "nowrap" }}
          >
            Open preview
          </IgButton>
          <IgButton
            variant="outlined"
            color="warning"
            href={GENERAL_ROUTES.GetHelp}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ flex: 1, marginLeft: "8px", whiteSpace: "nowrap" }}
          >
            Contact support
          </IgButton>
        </>
      }
      onClose={() =>
        dispatch(ExperienceBuilderAction.dismissPageState("networkBlocked"))
      }
    />
  );
};
